module.exports = __webpack_public_path__ + "img/marieclaire.d86f600e.jpg";